import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useStyles from '../../makeStyles';
import bindingIcon from '../../../../img/svgs/payment/binding.svg';

const AttachedCard = ({ attachedCard }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const formattedDate = useMemo(() => {
    if (attachedCard?.expDate) {
      return `${attachedCard.expDate.slice(-2)}/${attachedCard.expDate.slice(-4, -2)}`;
    }
    return '';
  }, [attachedCard]);

  return (
    <div className={classes.cardInfoWrapper}>
      <div className={classes.bindingIcon}>
        <img src={bindingIcon} alt="" />
      </div>
      <div className={classes.cardInfo}>
        <div>
          <div className={classes.cardPan}>
          &nbsp;&nbsp;&nbsp; **** &nbsp;&nbsp; **** &nbsp;&nbsp;  **** &nbsp;&nbsp;&nbsp;
            <div className={classes.digits}>{attachedCard?.cardPan?.slice(-4)}</div>
          </div>
          <div className={classes.validUntil}>
        &nbsp;&nbsp;&nbsp;&nbsp;
            {t('paymentMethods.expDate')}
          &nbsp;&nbsp;
            {formattedDate}
          </div>
        </div>
      </div>
    </div>
  );
};

AttachedCard.propTypes = {
  attachedCard: PropTypes.shape({
    cardPan: PropTypes.string,
    expDate: PropTypes.string,
  }),
};

AttachedCard.defaultProps = {
  attachedCard: {},
};
export default AttachedCard;
